import axios from 'axios';
import { QueryClient } from 'react-query';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const QrMenuApi = axios.create({
  timeout: 20000,
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      queryFn: ({ queryKey: [url] }) => {
        if (typeof url === 'string') {
          return QrMenuApi.get(`${backendUrl}${url}`).then((res) => res.data);
        }
        throw new Error('Invalid QueryKey')
      },
    },
  },
});